import i18n_cs from '@/assets/i18n/cs.json'

export default {
  cs: i18n_cs
}
